/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import styled, {css} from 'styled-components';

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
`;

const OptionLabel = styled.label`
  padding: 4px 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

const StyledButton = styled.button`
  background-color: ${props => css`${
    props.active && props.highlight_background_color ? props.highlight_background_color : 'transparent'
  } !important`};
  border-color: ${props => (props.active ? `transparent !important` : '#dce2e5 !important')};
  min-width: 50px;
  white-space: normal;
  padding: 5px;
  margin: 10px;
  border: 1px solid;
  font-size: 14px;
  flex: auto;
  &.first {
  }
  &.last {
  }
  &:not(.last):not(.first) {
  }
  &:hover {
    border-color: transparent !important;
    background-color: ${props => css`${
    props.hover_color ? props.hover_color : '#5375ad'
  }!important`};
    color: ${props => css`${props.highlight_color} !important`};
  }
  &:focus {
    outline:none !important;
  }
`;

export default class Index extends React.PureComponent {
  state = {
    active: null,
  };

  setActive = (name, value) => {
    const { onActiveCallback } = this.props;
    this.setState({ active: value });
    onActiveCallback(name, value);
  }

  componentDidMount() {
    const { activeDefault } = this.props;
    // eslint-disable-next-line no-unused-expressions
    this.setActive(activeDefault.name, activeDefault.value);
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const activeDefault = newProps.activeDefault;
    if (activeDefault) this.setState({ active: activeDefault.value })
  }

  render() {
    const { active } = this.state;
    const { option, styles } = this.props;
    return (
      <OptionWrapper>
        <OptionLabel>{option.name}</OptionLabel>
        <ButtonsContainer>
        {
          option.values.map((v, i) => (
            <StyledButton
              key={v}
              type="button"
              active={v === active}
              hover_color={styles.hover_color}
              onClick={() => this.setActive(option.name, v)}
              highlight_background_color={styles.active_background_color}
              highlight_color={styles.active_color}
              className={
                (i === 0 && 'first')
                || (i === option.values.length - 1 && 'last')
              }
            >
            {v}
            </StyledButton>
          ))
        }
        </ButtonsContainer>
      </OptionWrapper>
    );
  }
}
